import locale8db5ed1c from '../../lang/es.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"dateTimeFormats":{"en":{"simple":{"day":"2-digit","month":"2-digit","year":"numeric","pattern":"{day}/{month}/{year}"},"short":{"year":"numeric","month":"short","day":"2-digit"},"medium":{"day":"2-digit","month":"short","year":"numeric","hour":"numeric","minute":"numeric"},"long":{"weekday":"short","year":"numeric","month":"2-digit","day":"2-digit","hour":"numeric","minute":"numeric","second":"numeric","hour12":true}},"es":{"simple":{"day":"2-digit","month":"2-digit","year":"numeric","pattern":"{day}/{month}/{year}"},"short":{"year":"numeric","month":"short","day":"2-digit"},"medium":{"day":"2-digit","month":"short","year":"numeric","hour":"numeric","minute":"numeric"},"long":{"weekday":"short","year":"numeric","month":"2-digit","day":"2-digit","hour":"numeric","minute":"numeric","second":"numeric","hour12":false}}},"numberFormats":{"en":{"useGrouping":"auto"},"es":{"useGrouping":"always"},"de":{}},"fallbackLocale":"es"},
  vueI18nLoader: false,
  locales: [{"code":"es","file":"es.json"},{"code":"en","file":"en.json"}],
  defaultLocale: "es",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: true,
  langDir: "/usr/src/app/lang",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  silentTranslationWarn: true,
  normalizedLocales: [{"code":"es","file":"es.json"},{"code":"en","file":"en.json"}],
  localeCodes: ["es","en"],
  additionalMessages: [],
}

export const localeMessages = {
  'es.json': () => Promise.resolve(locale8db5ed1c),
  'en.json': () => import('../../lang/en.json' /* webpackChunkName: "lang-en.json" */),
}
